import { useTranslation } from "react-i18next";

const Users = () => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          {t("admin.users.title", "Users")}
        </h1>
        <p className="text-lg text-gray-600">
          {t("admin.users.upcomingFeature", "This is an upcoming feature")}
        </p>
      </div>
    </div>
  );
};

export default Users;
